import {useSelector, useDispatch} from "react-redux";
import {smsSliceActions} from "../Store/SendSms/SmsStore";

const SmsContent = () => {

    const data = useSelector(s => s.smsSliceReducer);
    const dispatch = useDispatch()

    console.log(data)
    return (
        <>
            <div className="sms-box">

                <div className="row-input">

                    <label className="form-check-label" htmlFor={"rnd1"}>
                        عنوان{" "}
                    </label>
                    <input
                        type="text"
                        name="lastCode"
                        placeholder={"عنوان متن را وارد کنید"}
                        autoComplete="off"
                        value={data.title}
                        onChange={(e) => dispatch(smsSliceActions.fillInput({title: e.target.value}))}
                    />
                </div>

                <div className="row-input">
                    <label className="form-check-label" htmlFor={"rnd1"}>
                        افزودن متن{" "}
                    </label>
                    <textarea
                        name="lastCode"
                        placeholder={"متن خود را وارد کنید"}
                        autoComplete="off"
                        value={data.boxAddText}
                        onChange={(e) => dispatch(smsSliceActions.fillInput({boxAddText: e.target.value}))}
                    />

                    <div className="abs-svg" onClick={() => dispatch(smsSliceActions.fillInput({mainText: data.mainText + " " + data.boxAddText}))}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75Z"
                                fill="#5A507B"/>
                            <path
                                d="M12 16.75C11.59 16.75 11.25 16.41 11.25 16V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V16C12.75 16.41 12.41 16.75 12 16.75Z"
                                fill="#5A507B"/>
                            <path
                                d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                                fill="#5A507B"/>
                        </svg>
                    </div>
                </div>

                <div className="row-input">
                    <label htmlFor={"rnd1"}>افزودن فیلد</label>

                    <div className="sms-fields">
                        <span>فیلد خود را وارد کنید</span>
                        <div className="sms-radio-boxes">
                            {data.initialData.fieldList.map((row, index) => <>
                                <div className="form-radio-control">
                                    <input
                                        onChange={e => dispatch(smsSliceActions.fillInput({addFieldObject: row}))}
                                        value={row.value}
                                        className="form-check-input"
                                        type="radio"
                                        name={"sameName"}
                                        id={index + "sms-form"}
                                        checked={data.addFieldObject.value === row.value}
                                    />
                                    <label className="form-check-label" htmlFor={index + "sms-form"}>
                                        {row.label}
                                    </label>
                                </div>
                            </>)}
                        </div>
                    </div>

                    <div className="abs-svg" onClick={() => dispatch(smsSliceActions.fillInput({mainText: data.mainText + " " + data.addFieldObject.label}))}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75Z"
                                fill="#5A507B"/>
                            <path
                                d="M12 16.75C11.59 16.75 11.25 16.41 11.25 16V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V16C12.75 16.41 12.41 16.75 12 16.75Z"
                                fill="#5A507B"/>
                            <path
                                d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                                fill="#5A507B"/>
                        </svg>
                    </div>
                </div>

            </div>
        </>
    );
};

export default SmsContent;
